import styled from "styled-components";

const StyledColumnContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export default StyledColumnContainer;
